const CAMPSITE_STATUS = {
  FULL: 'FULL',
  CLOSED: 'CLOSED',
};

export const CAMPSITE_CALENDAR_TEXT = {
  // Wording which displays on the calendar
  SITE_FULL: 'SITE FULL',
  PITCH_FULL: 'PITCH FULL',
  CLOSED: 'CLOSED',
  ON_REQUEST: 'Contact Us',
  // Wording which is hidden
  AVAILABLE: 'AVAILABLE',
};

export default CAMPSITE_STATUS;
